export default {"src":"/_next/static/media/v.1f64ad1a.svg","height":15,"width":16,"blurWidth":0,"blurHeight":0};